import axios from "./axios-config";
import type { SnowflakeId } from "@/types/snowflake";
import type { TaskSubtype, TaskSubtypeWrite } from "@/types/task-subtype";
import type { ResolutionReason } from "@/api/taskResolutionReasonsApi";

const BASE = "/pms/task-subtypes";

export const taskSubtypeApi = {
  search: (params: any) => axios.post(`${BASE}/search`, params),
  /**
   * POST /pms/task-subtypes/lookup — full-set, version-cached (写 subtype →
   * listener bump → 自动失效，0 陈旧窗口)。下拉/标签 map 的 consume 路径优先用本
   * 端点而非 /search。返回精简行 `[{id, code, label, labelI18n, iconUrl, taskTypeCode}]`
   * (labelI18n 供按界面语言显示,见 utils/subtypeLabel)。
   */
  lookup: () =>
    axios.post<unknown, any[]>(`${BASE}/lookup`, {
      nameFields: "id code label labelI18n iconUrl taskTypeCode",
      orderBy: "sortOrder",
      filters: { isEnabled: { type: "boolean", value: true } },
    }),
  getById: (id: SnowflakeId) => axios.get<any, TaskSubtype>(`${BASE}/${id}`),
  create: (data: TaskSubtypeWrite) =>
    axios.post<any, TaskSubtype>(BASE, data),
  update: (id: SnowflakeId, data: TaskSubtypeWrite) =>
    axios.put<any, TaskSubtype>(`${BASE}/${id}`, data),
  delete: (id: SnowflakeId) => axios.delete(`${BASE}/${id}`),
  /**
   * GET /pms/task-subtypes/{id}/available-reasons — 契约 C4.
   * Enriched view of this subtype's SELECTED resolution reasons: label/i18n
   * resolved from catalog, `targetWfStage` = subtype-level override, and
   * `isActiveInCatalog` (false = soft-deleted in catalog but still referenced →
   * admin should clean up). Optional `outcome` filters to one action bucket.
   */
  availableReasons: (
    id: SnowflakeId,
    outcome?: "completed" | "on_hold" | "cancelled",
  ) =>
    axios.get<unknown, ResolutionReason[]>(`${BASE}/${id}/available-reasons`, {
      params: outcome ? { outcome } : undefined,
    }),
};
